import di from "../di/servicelocator";
import React, { useEffect, useState } from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/FilterAssetDrop.scss";
import { FilterTabEnum } from "@frameworks/web/components/Reports/CommonComponent/constant";
const FilterAssetDrop = ({ setshowFilterAssetDropdown, filterData, setFilterData, filterOpen, setFilterOpen, showAsset, keyTab, themeClass, }) => {
    var _a, _b, _c, _d, _e, _f;
    const [selectedFilters, setselectedFilters] = useState(filterData.simpleFilter.filters.filter((x) => x.selected).length);
    const [selectedAssetFilters, setselectedAssetFilters] = useState(filterData.assetFilter.filters.filter((x) => x.selected).length);
    const { simpleFilter, assetFilter, productAssetFilter } = filterData;
    const [tempfilterData, setTempFilterData] = useState(null);
    const handleChange = (eventKey, checked, filterType, setFilterCount) => {
        let { name, filters } = tempfilterData[filterType];
        filters = filters.map((filter) => {
            if (filter.key === eventKey)
                return Object.assign(Object.assign({}, filter), { selected: checked });
            return filter;
        });
        setFilterCount(filters.filter((x) => x.selected).length);
        setTempFilterData(Object.assign(Object.assign({}, tempfilterData), { [filterType]: { name, filters } }));
    };
    const applyFilter = async () => {
        let selectedAssetCategories = tempfilterData.assetFilter.filters.reduce((assetCategories, asset) => {
            if (asset.selected)
                assetCategories.push(asset.key);
            return assetCategories;
        }, []);
        if (selectedAssetCategories.length > 0 && keyTab === FilterTabEnum.ALL)
            sessionStorage.setItem("assetFilter", JSON.stringify(selectedAssetCategories));
        setFilterData === null || setFilterData === void 0 ? void 0 : setFilterData(tempfilterData);
        di.holdingReport.getFilteredHoldingReportData(tempfilterData);
        setshowFilterAssetDropdown(false);
    };
    const clearAllFilter = async () => {
        const defaultFilter = simpleFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        const defaultAssetFilter = assetFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        sessionStorage.removeItem("assetFilter");
        di.holdingReport.getFilteredHoldingReportData({
            simpleFilter: { name: "Filter By", filters: defaultFilter },
            assetFilter: { name: "Asset filter", filters: defaultAssetFilter },
            productAssetFilter: productAssetFilter,
        });
        setselectedFilters(0);
        setselectedAssetFilters(0);
        setshowFilterAssetDropdown(false);
    };
    const arrow = () => {
        setFilterOpen((prevstate) => !prevstate);
    };
    useEffect(() => {
        setTempFilterData(filterData);
    }, []);
    return (React.createElement("div", { className: `${themeClass !== null && themeClass !== void 0 ? themeClass : "filterasset-drop "}` },
        React.createElement("div", { id: "filter", className: "filterasset-drop-head", onClick: () => arrow() },
            React.createElement("p", null,
                simpleFilter.name,
                React.createElement("span", { className: "color_blue" }, `(${selectedFilters})`)),
            React.createElement("span", null, filterOpen ? (React.createElement("i", { className: "edel-icon-arrow-up color_blue" })) : (React.createElement("i", { className: "edel-icon-arrow-down color_blue" })))),
        React.createElement("div", { id: "filter-show-hide", className: "filterasset-drop-body", style: {
                display: filterOpen ? "block" : "none",
            } },
            React.createElement("ul", null, (_c = (_b = (_a = tempfilterData === null || tempfilterData === void 0 ? void 0 : tempfilterData.simpleFilter) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 : _c.call(_b, (val, idx) => {
                return (React.createElement("li", { key: idx },
                    React.createElement("label", { className: "checkbox" },
                        React.createElement("input", { type: "checkbox", checked: val.selected, value: val.key, onChange: (e) => handleChange(e.target.value, e.target.checked, "simpleFilter", setselectedFilters) }),
                        React.createElement("span", { className: "checked edel-icon-tick" }),
                        React.createElement("p", null, val.title))));
            }))),
        showAsset && (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "asset", className: "filterasset-drop-head", onClick: () => arrow() },
                React.createElement("p", null,
                    assetFilter.name,
                    React.createElement("span", { className: "color_blue" }, `(${selectedAssetFilters})`)),
                React.createElement("span", { className: "pd-r5" }, !filterOpen ? (React.createElement("i", { className: "edel-icon-arrow-up color_blue" })) : (React.createElement("i", { className: "edel-icon-arrow-down color_blue" })))),
            React.createElement("div", { id: "asset", className: "filterasset-drop-body", style: { display: !filterOpen ? "block" : "none" } },
                React.createElement("ul", null, (_f = (_e = (_d = tempfilterData === null || tempfilterData === void 0 ? void 0 : tempfilterData.assetFilter) === null || _d === void 0 ? void 0 : _d.filters) === null || _e === void 0 ? void 0 : _e.map) === null || _f === void 0 ? void 0 : _f.call(_e, (val, idx) => {
                    return (React.createElement("li", { key: idx },
                        React.createElement("label", { className: "checkbox" },
                            React.createElement("input", { type: "checkbox", checked: val.selected, value: val.key, onChange: (e) => handleChange(e.target.value, e.target.checked, "assetFilter", setselectedAssetFilters) }),
                            React.createElement("span", { className: "checked edel-icon-tick" }),
                            React.createElement("p", null, val.title))));
                }))))),
        React.createElement("div", { className: "filterasset-drop-footer" },
            React.createElement("input", { className: "filter-button clear_all", type: "button", value: "Clear All", onClick: () => keyTab === FilterTabEnum.ALL
                    ? clearAllFilter()
                    : di.holdingReport.clearSingleFilter("simpleFilter") }),
            React.createElement("input", { 
                // className={`filter-button aply-btn ${
                //   selectedFilters === 0 && selectedAssetFilters === 0
                //     ? ""
                //     : "setbackGround"
                // }`}
                className: selectedFilters > 0 || selectedAssetFilters > 0
                    ? "filter-button aply-btn"
                    : "filter-button-disable", type: "button", value: "Apply", onClick: applyFilter }))));
};
export default FilterAssetDrop;
